import { getRelatedItemLink } from "utilities/relatedItem/relatedItem";

import { RelatedItemType } from "commonComponents/entity/relatedItem/RelatedItem.types";
import { RelatedItemTag } from "commonComponents/entity/relatedItem/RelatedItemTag/RelatedItemTag";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import { type GridLineItemColumn } from "commonComponents/utilities/LineItemContainer/types/LineItem.interfaces";

import { type ILineItemRelatedItem } from "entity/hawk/api/lineItem.api.types";

export interface ILineItemRelatedItemsCellProps {
    relatedItems: ILineItemRelatedItem[];
    lineItemId: number;
    jobId: number;
    permissionsRecord: Record<RelatedItemType, boolean>;
}

export function LineItemRelatedItemsCell({
    cellValue,
}: IGridCellRenderProps<ILineItemRelatedItemsCellProps, GridLineItemColumn<unknown, unknown>>) {
    if (!cellValue?.relatedItems?.length || !cellValue.jobId || !cellValue.lineItemId) {
        return null;
    }
    return (
        <>
            {cellValue.relatedItems.map((item) => {
                if (!item.id || !item.type) {
                    return null;
                }
                const canViewEntity = cellValue.permissionsRecord[item.type as RelatedItemType];
                return (
                    <RelatedItemTag
                        key={`${item.type}-${item.id}`}
                        to={
                            canViewEntity
                                ? getRelatedItemLink(
                                      item.id,
                                      item.type as RelatedItemType,
                                      cellValue.jobId,
                                  )
                                : undefined
                        }
                        data-testid={`relatedTag-${item.type}-${item.id}-${cellValue.lineItemId}`}
                        itemType={item.type as RelatedItemType}
                        subject={item.title ?? undefined}
                        isToFullUrl={(item.type as RelatedItemType) === RelatedItemType.Estimate}
                        isDisabled={!canViewEntity}
                    />
                );
            })}
        </>
    );
}
